import {useEffect, useState} from "react";
import styled from "styled-components";
import {DText} from "../../styles/CommonStyles";
import {useProfileQuery} from "../../services/react-query/useProfileQuery";
import Text from "../../utils/Text";
import {formatNumber} from "../../utils/common";
import {useAuthContext} from "../../contexts/auth";


const CurrencyBalance = (props) => {
    const { tradeType, currency, onBalanceClicked } = props

    const { profile } = useAuthContext()
    const [balance, setBalance] = useState(0)

    useEffect(() => {
        if (profile && tradeType && currency) {
            let _balance = 0;
            if (tradeType === 'buy') _balance = profile?.balance
            else {
                const coin = profile?.coins?.find(c => c.coin === currency)
                if (coin) _balance = coin.amount
            }
            setBalance(_balance)
        }
    }, [profile, tradeType, currency])

    return (
        <BalanceWrapper onClick={() => onBalanceClicked(balance)} {...props}>
            <DText>
                <Text tid={'balance'} /> :
            </DText>
            <DText style={{ margin: '2px 5px 0 5px', direction: 'ltr' }}>
                {`${formatNumber(balance)} ${currency?.toUpperCase()}`}
            </DText>
        </BalanceWrapper>
    )
}

const BalanceWrapper = styled.div`
  width: 40%;
  margin: 0 auto;
  display: flex;
  align-items: center;
  min-height: 32px;
  border-radius: 4px;
  padding: 0 10px;
  cursor: pointer;
  
  @media screen and (max-width: 1050px){
    width: 70%;
  };
`

export default CurrencyBalance;
